import { isEarlyReader } from "../../../../../services/EarlyReaderService";

export default function getNonEarlyReaderCount(report) {
    if(!report || !report.data || !report.data.length) return 0
    return report.data.filter(studentData => !isEarlyReader(studentData)).length;
}
